/* eslint-disable */

import store from '../store';
import i18next from "i18next";
import {HTTP_HYPER_ESPACE_BACKEND} from "@/services/http-common";

/**
 * Get the "definitionDonnee" of listed data
 * @param payload
 * @returns {Promise<*>}
 */
export async function getList(payload) {

    let params = {
        params: {
            codes: payload.fields.toString(),
        }
    };

    return HTTP_HYPER_ESPACE_BACKEND
        .get('/definition-donnee', params)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return {type: "error", message: error}
        })
}

/**
 * Get the offer types
 * @returns {Promise<*>}
 */
export async function getOfferTypes(){

    let sitimmoUser = store.getters.getSitimmoUser;

    let params = {
        params: {
            metier: sitimmoUser.metier,
            language: i18next.language
        }
    };

    return HTTP_HYPER_ESPACE_BACKEND
        .get('/type_offre', params)
        .then(response => {
            store.commit('setOfferTypes', response.data._embedded.type_offre);
            return response.data._embedded.type_offre
        })
        .catch(error => {
            return {type: "error", message: error}
        })
}

/**
 * Get the objects types
 * @returns {Promise<*>}
 */
export async function getObjectTypes(annonceParente, annonceur = null, metier = null){

    let sitimmoUser = store.getters.getSitimmoUser;
    if(!metier) {
        metier = sitimmoUser.metier;
    }

    let params = {
        params: {
            metier: metier,
            annonce_parente: annonceParente,
            annonceur: annonceur,
            language: i18next.language
        }
    };
    return HTTP_HYPER_ESPACE_BACKEND
        .get('/type_objet', params)
        .then(response => {
            return response.data._embedded.type_objet
        })
        .catch(error => {
            return {type: "error", message: error}
        })
}
